// extracted by mini-css-extract-plugin
export default {"Pod":"YWW7nysKAQa3mSnqEE6Z"};